function matchesStrictComparable(t,e){return function(r){return null==r?!1:r[t]===e&&(void 0!==e||t in Object(r))}}module.exports=matchesStrictComparable;